import {
  SCREENING_QUESTION_CODES,
  SCREENING_QUESTION_TYPES,
} from "../screeningQuestionsData";

export const emergencyContactsQuestions = {
  [SCREENING_QUESTION_CODES.emergency_contact]: {
    title: "Add your emergency contact",
    type: SCREENING_QUESTION_TYPES.emergency_contact,
  },
} as const;
